<section>
    <h1>Hagrid<small> Gridify Scatterplots with Hilbert and Gosper Curves</small></h1>
    <img src="images/teaser_image.png" alt="teaser" />
    <h5>Rene Cutura ❖ Cristina Morariu ❖ Zhanglin Cheng ❖ Yunhai Wang ❖ Daniel Weiskopf ❖ Michael Sedlmair</h5>
    <aside class="notes">
        hello my name is rene cutura, and i present Hagrid a method to gridify scatterplots with 
        the help of two space filling curves, the hilbert and the gosper curve.
    </aside>
</section>


